import React, { useState } from "react";
import { useTableHeaderRow } from "common/Table/TableHeaderRow";
import { SmartLayoutConfig } from "common/Lists/types";

export const SmartTableLayout = ({
  isDrawerTable,
  titleOrNode,
  withSearch,
  searchPlaceholder,
  actionTrigger = null,
  actionModal: ActionModal,
  actionComponent,
  tableComponent,
  showLayoutChangeButton,
  numOfItems,
  layoutChangeKey,
  sortSelect,
}: SmartLayoutConfig) => {
  const [isActionModalOpen, setActionModalOpen] = useState(false);

  const openModal = () => setActionModalOpen(true);
  const { tableHeader, isCardsView, searchValue } = useTableHeaderRow({
    isDrawerTable,
    actionTrigger: actionComponent ?? (
      <div onClick={openModal}>{actionTrigger}</div>
    ),
    titleOrNode,
    withSearch,
    searchPlaceholder,
    numOfItems,
    showLayoutChangeButton,
    layoutChangeKey,
    sortSelect,
  });

  let tableComponentProps = {
    searchFilter: searchValue,
    isCardsView,
  };

  return (
    <>
      {tableHeader}
      {React.cloneElement(tableComponent, tableComponentProps)}
      {isActionModalOpen && actionTrigger && ActionModal && (
        <ActionModal closeModal={() => setActionModalOpen(false)} />
      )}
    </>
  );
};
